// components/Header.jsx
import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { IoMenu } from "react-icons/io5";

const Header = () => {
  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [drawerOpen, setDrawerOpen] = useState(false);

  const navLinks = [
    "Home",
    "About Me",
    "Skills",
    "Experience",
    "Projects",
    "Contact",
  ];

  const handleDrawerToggle = () => setDrawerOpen(!drawerOpen);

  return (
    <>
      <AppBar
        position="sticky"
        sx={{ backgroundColor: theme.palette.background.default }}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Typography
            variant="h6"
            // sx={{ fontWeight: "bold", letterSpacing: "1px" }}
          >
            Pratik Shinde
          </Typography>

          {isMobile ? (
            // <>
            //   <IconButton
            //     edge="start"
            //     color="inherit"
            //     aria-label="menu"
            //     onClick={handleDrawerToggle}
            //   >
            //     {/* <MenuIcon /> */}
            //   </IconButton>
            // </>
            <Box sx={{ display: { xs: "block", md: "none" } }}>
              <IconButton
                edge="start"
                color="inherit"
                aria-label="menu"
                onClick={handleDrawerToggle}
              >
                <IoMenu />
              </IconButton>
            </Box>
          ) : (
            <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
              {navLinks.map((item) => (
                <Button
                  key={item}
                  // href={`#${item.toLowerCase().replace(" ", "")}`}
                  onClick={() =>
                    handleScroll(`${item.toLowerCase().replace(" ", "")}`)
                  }
                  sx={{
                    color: theme.palette.text.primary,
                    textTransform: "none",
                    fontWeight: 500,
                  }}
                >
                  {item}
                </Button>
              ))}
              <Button
                variant="contained"
                sx={{
                  backgroundColor: theme.palette.primary.main,
                  color: theme.palette.text.primary,
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: theme.palette.primary.dark,
                  },
                }}
                href="mailto:pratikshinde7262@gmail.com?subject=Hiring%20Inquiry&body=Hi%20there!"
              >
                Hire Me
              </Button>
            </Box>
          )}
        </Toolbar>
      </AppBar>

      <Drawer anchor="right" open={drawerOpen} onClose={handleDrawerToggle}>
        <Box
          sx={{ width: 250 }}
          role="presentation"
          onClick={handleDrawerToggle}
        >
          <List>
            {navLinks.map((text) => (
              <ListItem
                button
                key={text}
                component="a"
                href={`#${text.toLowerCase().replace(" ", "")}`}
              >
                <ListItemText
                  sx={{ color: theme.palette.text.primary }}
                  primary={text}
                />
              </ListItem>
            ))}
            <ListItem>
              <Button
                variant="contained"
                fullWidth
                sx={{
                  backgroundColor: theme.palette.primary.main,
                  color: theme.palette.text.primary,
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: theme.palette.primary.dark,
                  },
                }}
                href="mailto:pratikshinde7262@gmail.com?subject=Hiring%20Inquiry&body=Hi%20there!"
              >
                Hire Me
              </Button>
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </>
  );
};

export default Header;
